import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_slider = _resolveComponent("base-slider")

  return (_openBlock(), _createBlock(_component_base_slider, {
    "is-processing": _ctx.isProcessing,
    "scroll-container-classes": "gfu-project-explorer-card-wrapper",
    tags: $props.tags,
    items: $options.projectItems,
    "can-load-more-rows": $options.canLoadMoreRows,
    "slide-gap-classes": "_px-2 _px-3--m",
    "scroll-container-wrapper-classes": "_pos-r _-mx-2 _-mx-3--m",
    "default-tag-key": $props.defaultTagKey,
    "large-screen-visible-items-count": $props.largeScreenVisibleItemsCount,
    "extra-large-screen-visible-items-count": $props.extraLargeScreenVisibleItemsCount,
    "show-empty-state": $props.showEmptyState,
    "show-single-tag": $props.showSingleTag,
    "aria-busy": _ctx.isProcessing,
    onGetItems: $options.getItems,
    onLoadMore: $options.getMoreItems,
    onTagClicked: $options.onTagClicked,
    onViewAll: $options.onViewAllClick,
    onScrollRight: $options.onScrollRight,
    onScrollLeft: $options.onScrollLeft
  }, {
    prefix: _withCtx(() => [
      _renderSlot(_ctx.$slots, "prefix")
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["is-processing", "tags", "items", "can-load-more-rows", "default-tag-key", "large-screen-visible-items-count", "extra-large-screen-visible-items-count", "show-empty-state", "show-single-tag", "aria-busy", "onGetItems", "onLoadMore", "onTagClicked", "onViewAll", "onScrollRight", "onScrollLeft"]))
}